'use strict';

import { $PATCH } from '../../plugins/Fetch';

window.StaffConfirmStatus = () => {
  let data = {
    saving: false,
    shouldCancel: false,
    toast: {
      success: '',
      error: null,
    },
    statuses: [],
  };
  return {
    ...data,
    init() {
      let config = window.app_data;
      for (let k in config) {
        this[k] = config[k];
      }
    },
    setStatus(e) {
      let record = this.shift || this.shift_able;
      record.status = e.target.dataset.status;
    },
    reset() {
      this.toast.success = this.toast.error = null;
      this.shouldCancel = false;
    },
    confirm() {
      this.save({ status: 'confirmed' }).then((resp) => {
        if (resp.id) {
          this.shift.status = 'confirmed';
        }
      });
    },
    cancel() {
      this.save({ status: 'cancelled_by_staff' }).then((resp) => {
        if (resp.id) {
          this.shift.status = 'cancelled_by_staff';
        }
      });
    },
    save(params) {
      if (this.saving) return Promise.resolve({});

      this.saving = !this.saving;
      this.reset();
      let data = this.shift
        ? {
            id: this.shift.id,
            shift: {
              id: this.shift.id,
              ...params,
            },
          }
        : { shift_able: this.shift_able };
      return this.request(this.routes.rsvp, data)
        .then((resp) => {
          if (resp.id) {
            this.toast.success = 'Saved!';
            return resp;
          } else if (resp.errors) {
            this.toast.error = resp.errors.join(', ');
            return {};
          } else {
            this.toast.error = 'Oops there was an error. Please contact us';
            return {};
          }
        })
        .catch((err) => {
          this.toast.error = 'Oops there was an error. Please contact us';
          return {};
        })
        .finally(() => {
          this.saving = !this.saving;
          setTimeout(() => {
            this.reset();
          }, 3000);
        });
    },
    request(url, data) {
      let body = {
        event_id: this.eventId,
        token: this.token,
        ...data,
      };

      return $PATCH(url, body)
        .then((resp) => resp)
        .catch((err) => {
          return { errors: [err.message] };
        });
    },
  };
};
